const link_list = {
    routePath: 'opportunitys',
    actionName: 'count',
    iconClass: 'fa-solid fa-gauge',
    title: 'My Active Opportunitys',
    search: {
        status:{
            key:'status',
            value:'Open'
        }
    },
    sort: {
        order: 'asc',
        column: 'date_entered',
    },
    perPage: '',
}
export default {link_list }